exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir=ltr] .footer-container .van-cell__title{padding-left:.35rem;border-left:.2rem solid #ffc72b}[dir=rtl] .footer-container .van-cell__title{padding-right:.35rem;border-right:.2rem solid #ffc72b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b62359de","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/footerView.vue
// module id = MpdJ
// module chunks = 5 10